var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadCanary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 32,
    viewBox: "0 0 41 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7555 5.77845C40.6533 5.54192 40.4151 5.37293 40.1431 5.37293H18.3988L14.6218 0.270469C14.4858 0.10147 14.2814 0 14.0774 0L6.38678 0.000353552H6.3526H6.2846H6.21659C6.18241 0.000353552 6.18241 0.000353552 6.14859 0.0342945C6.11441 0.0342945 6.11441 0.0342945 6.08058 0.0682355C6.0464 0.0682355 6.0464 0.102176 6.01258 0.102176C5.9784 0.102176 5.9784 0.136117 5.94457 0.136117L5.91039 0.170058C5.87621 0.170058 5.87621 0.203999 5.84239 0.203999L5.80821 0.23794L0.159479 6.89353C-0.0107133 7.09612 -0.0445385 7.36659 0.0572923 7.60311C0.159479 7.83964 0.397676 8.00864 0.669699 8.00864H5.706V18.2135C5.706 18.2811 5.706 18.3486 5.74018 18.3825V18.4165C5.77436 18.484 5.77436 18.518 5.84237 18.5855L15.3026 31.5609C15.3368 31.6284 15.4048 31.7299 15.4728 31.7974C15.6088 31.9325 15.779 32 15.9492 32H36.7748C37.081 32 37.3192 31.831 37.4214 31.5609C37.5235 31.2904 37.4214 30.9864 37.2173 30.8174L25.8858 21.8969L40.6208 6.52208C40.8248 6.31949 40.8928 6.01543 40.7568 5.77891L40.7555 5.77845ZM7.06716 1.31807H13.7367L17.1736 5.9811L7.06707 16.558L7.06716 1.31807ZM2.13303 6.65702L5.70595 2.50066V6.65702H2.13303ZM34.8005 30.6483H17.5134L24.9658 22.8765L34.8005 30.6483ZM15.9821 30.2428L7.27106 18.3146L18.3647 6.72486H38.544L15.9821 30.2428Z",
    fill: "url(#paint0_linear_229_334)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_229_334",
    x1: 12.4798,
    y1: 13.9451,
    x2: 58.0362,
    y2: 29.7659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838542,
    stopColor: "#01FFC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadCanary);
export default __webpack_public_path__ + "static/media/download_canary.svg";
export { ForwardRef as ReactComponent };